// extracted by mini-css-extract-plugin
export default {"item":"Item_item__ZbU5g","active":"Item_active__bGva-"};